module.exports = __webpack_public_path__ + "static/scale-model-of-spring-garden-point-park-in-hialeah-florida-e0ba703b5c1d16bc61057e549fa405e4.png";